namespace advisorop.components.common {
    
    class AccountDetailsController {
        $router;
        model: domains.IAccount;
        refreshHouseholds: boolean;
        rtqs: domains.IRTQ;
        investorId: number = 0;
        proposals: Array<domains.IProposal>;

        static $inject = ["advisorService", "generalService"];
        constructor(private advisorService: services.AdvisorService, private generalService: services.GeneralService) {            
        }

        rtqTabSelected(): void {
            this.advisorService.getRTQs(this.investorId)
                .then(response => {
                    this.rtqs = <domains.IRTQ>response.data;
                },
                err => this.generalService.showError(err));
        };

        proposalsTabSelected(): void {
            this.advisorService.getProposalsByTitle(this.investorId)
                .then(response => this.proposals = response.data,
                    err => this.generalService.showError(err));
        };
        
        holdingsTablSelected(): void {
            this.refreshHouseholds = !this.refreshHouseholds;
        };


        $onInit(): void {            
        };

        $routerOnActivate(next, previous) {

            this.investorId = <number>next.params.id;

            this.advisorService.getInvestor(this.investorId).then(response => {
                this.model = <domains.IInvestor>response.data;
            }, err => this.generalService.showError(err));
        }
    }


    class AccountDetails implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = AccountDetailsController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<"
            };
            this.templateUrl = "spa/shared/common/account-details.html";
        }

    }
    angular.module(Constants.APP).component("accountDetails", new AccountDetails());


}